export const WarehousesActionTypes = {
    API_RESPONSE_SUCCESS: '@@warehouses/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@warehouses/API_RESPONSE_ERROR',
    READ_ALL_WAREHOUSES_REQUEST: '@@warehouses/READ_ALL_WAREHOUSES_REQUEST',
    CREATE_WAREHOUSE_REQUEST: '@@warehouses/CREATE_WAREHOUSE_REQUEST',
    UPDATE_WAREHOUSE_REQUEST: '@@warehouses/UPDATE_WAREHOUSE_REQUEST',
    DELETE_WAREHOUSE_REQUEST: '@@warehouses/DELETE_WAREHOUSE_REQUEST',
    RESET_STATE: '@@warehouses/RESET_STATE',
    RESET_ALL_ERRORS: '@@warehouses/RESET_ALL_ERRORS',
};
